// frontend/src/hooks/useLocationData.js
//
// Mutation hooks for the Locations resource. Per-row writes only —
// the bulk-save flow on LocationSetup uses the SSRM grid pattern and is
// not part of this file.
//
// Read query for the locations LIST lives in StoreDataContext (cached
// at 5min).

import { apiJson } from '../queries/api';
import { DATA } from '../queries/dataChanged';
import { useApiMutation } from '../queries/useApiMutation';

const API = '/api/locations/';


/**
 * Create a new location.
 */
export function useCreateLocation() {
  return useApiMutation({
    mutationFn: (payload) => apiJson.post(API, payload),
    changes: [DATA.locations],
  });
}


/**
 * Patch fields on a single location. Used for the Edit Location dialog,
 * calendar assignment, fulfillment toggles, and any partial update from
 * a dialog or cell edit.
 *
 * Variables: { id, payload }
 */
export function useUpdateLocation() {
  return useApiMutation({
    mutationFn: ({ id, payload }) => apiJson.patch(`${API}${id}/`, payload),
    changes: [DATA.locations],
  });
}


/**
 * Bulk-update LocationSetup grid changes. Sibling of the per-row
 * mutations above; the LocationSetup page uses this for the
 * "Save Changes" button after editing N rows.
 *
 * Variables: { items } where items is `[{ id, fields }, ...]`.
 */
export function useLocationBulkUpdate() {
  return useApiMutation({
    mutationFn: ({ items }) => apiJson.post(`${API}bulk-update/`, { items }),
    changes: [DATA.locations],
    edits: ['/api/locations/'],
  });
}
